import { ExitScreen } from '@dora/components';
import * as Hooks from 'preact/hooks';
import Preact from 'preact';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { AppControlContext } from './context/appControl';
import { AsyncResult } from './hooks/useAsync';

export interface Props {
    open: boolean;
    onCancel: () => void;
    /** Size of CTA button combo, large on desktop, medium on mobile */
    size: 'large' | 'medium';
    copyToClipboard: (text: string) => void;
    sharingUrlRequest: AsyncResult<string | undefined>;
    primaryCtaText: string;
    secondaryCtaText: string;
    titleText: string;
    linkError: string;
    linkLoading: string;
    linkHelperText: string;
    linkCtaText: string;
}

export function Component(p: Props) {
    const appControl = Hooks.useContext(AppControlContext);
    const theme = useTheme();

    return (
        <Fade
            in={p.open}
            exit
            appear={false}
            timeout={{
                enter: 300,
                exit: 300,
            }}
        >
            <Box
                width="100%"
                height="100%"
                position="absolute"
                zIndex={theme.zIndex.tooltip} // needs to show above RendererError, Drawer and FAB (snackbar)
            >
                <ExitScreen.Component
                    onExit={() => appControl?.closeApp()}
                    onCancel={p.onCancel}
                    size={p.size}
                    sharingUrlResult={p.sharingUrlRequest.result}
                    sharingUrlError={p.sharingUrlRequest.error}
                    sharingUrlRetry={p.sharingUrlRequest.retry}
                    copyToClipboard={p.copyToClipboard}
                    primaryCtaText={p.primaryCtaText}
                    secondaryCtaText={p.secondaryCtaText}
                    titleText={p.titleText}
                    linkError={p.linkError}
                    linkHelperText={p.linkHelperText}
                    linkLoading={p.linkLoading}
                    linkCtaText={p.linkCtaText}
                />
            </Box>
        </Fade>
    );
}
